import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import birthdayCake from "../../asset/images/cake.svg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import axios from "axios";
import { DASHBOARD_DEFAULT } from "../../Configuration/API_URL";
import Loader from "../../Components/Common/Loader";
import birthdayIcon from "../../asset/images/icons/birthday.svg";
import { Constants } from "../../CommonMethhods/Constants";
import RoundLoader from "../Common/RoundRingLoader";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import {
  AESEncryption,
  ApiResDecrypt,
  noDataFound,
} from "../../CommonMethhods/CommonMethods";
import LoaderForSearch from "../Common/LoaderForSearch";
import { useDebounce } from "../useDebounce";

function BirthdaySlider() {
  const storeToken = localStorage.getItem("ssoToken");

  const [birthdayNames, setBirthdayNames] = useState([]);
  const [loader, setLoader] = useState(true);
  const [sendWishLoader, setSendWishLoader] = useState(false);
  const [sliderItemCount, setSliderItemCount] = useState();
  const [nameInitials, setnameInitials] = useState([]);
  const [nameTrue, setNameTrue] = useState(false);
  const [nameHandle, setNameHandle] = useState("");
  const [width, setWidth] = useState("");
  const [totalClients, setTotalClients] = useState();
  const [showModal, setShowModal] = useState(false);
  const [resForModal, setResForModal] = useState([]);
  const [errorModal, setErrorModal] = useState(false);
  const [modalLoader, setModalLoader] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [modalScrollLoader, setModalScrollLoader] = useState(false);
  const [clientSearch, setClientSearch] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [sendWishindiLoader, setSendWishindiLoader] = useState(false);
  const debouncedValue = useDebounce(clientSearch, 1000);
  useEffect(() => {
    handleClientSearch(debouncedValue);
  }, [debouncedValue]);

  //attributes  for birthday slider
  const birthdaySlider = {
    infinite: true,
    slidesToShow: sliderItemCount,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "0px",
    autoplay: true,
    responsive: [
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  };

  // debugger
  // api call for send wish
  const sendBirthdayWishCommon = async (sendTypeFinal) => {
    // let a;
    if (sendTypeFinal === "all") {
      setSendWishLoader(true);
      // a = {};
    }
    if (sendTypeFinal === "individual") {
      setSendWishindiLoader(true);
      // a = { clientCode: selectedFiles.toString() };
    }
    let payloadValue = {
      sendTypeFinal: "all" ? {} : { clientCode: selectedFiles.toString() },
    };
    let encPayload = AESEncryption(payloadValue);

    try {
      const sendWish = await axios.post(
        DASHBOARD_DEFAULT.SendBirthdayWishEmail_URL,
        `"${encPayload}"`,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(sendWish?.data);
      // const res = sendWish?.data;
      if (res?.status === 0) {
        toast.success(res?.data);
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.message);
    } finally {
      if (sendTypeFinal === "all") {
        setSendWishLoader(false);
      }
      if (sendTypeFinal === "individual") {
        setSendWishindiLoader(false);
      }
    }
  };
  // api call for getting birthday details
  const getBirthDayDetails = async () => {
    let payloadValue = {
      pageNo: 1,
      pageSize: 10,
      search: "",
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getBirthday = await axios.post(
        DASHBOARD_DEFAULT.GetBirthdayList_URL,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      let res = ApiResDecrypt(getBirthday?.data);
      const response = res?.data;
      setTotalClients(response.totalCount);
      const names = [];
      const codes = [];
      const initials = [];
      // looping to get firstname and lastname
      response.birthdays.forEach((person) => {
        const name = person.userName;
        const iconName = name.trim();
        const array = iconName.split(" ");
        const firstname = array[0];
        const lastname = array[array.length - 1];
        initials.push(firstname.charAt(0) + lastname.charAt(0));
        names.push(firstname + " " + lastname);
        codes.push(person.userId);
      });
      // setting bday names and clientcodes
      setBirthdayNames(names);
      setnameInitials(initials);
      setLoader(false);
      // setting slider count based on birthdaynames
      if (names.length <= 0) {
      } else if (names.length > 0 && names.length <= 3) {
      } else if (names.length > 3 && names.length <= 5) {
        setSliderItemCount(3);
        setWidth("225px");
      } else {
        setSliderItemCount(5);
        setWidth("320px");
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  function nameSet(e) {
    setNameHandle(e);
    setNameTrue(true);
  }

  // if there is no bday
  function handlingZeroBday() {
    return (
      <div className="no-data">
        <img src={birthdayIcon} alt="birthdayIcon" />
        <span>{Constants.No_Birthday}</span>
      </div>
    );
  }
  //  if the bday count is below 3 and above zero
  function handleBdayCountBetweenOneTOThree(birthdayNames, nameInitials) {
    return (
      <>
        <div className="birthdays">
          {birthdayNames.map((element, key) => (
            <div className="profile-icon" key={key}>
              <div onClick={() => nameSet(birthdayNames[key])}>
                {nameInitials[key] === "" || null || undefined
                  ? "UN"
                  : nameInitials[key]}
                <span className="name-hover">
                  {birthdayNames[key] === " " || null || undefined
                    ? "UNKNOWN"
                    : birthdayNames[key]}
                </span>
              </div>
            </div>
          ))}
        </div>
        <div className="block1-names">
          <h2>
            <span>
              {`${Constants.Wish}${" "}`}
              {birthdayNames[0] === " " || null || undefined
                ? "Unknown"
                : birthdayNames[0]}
            </span>
            {birthdayNames.length > 1
              ? `and ${birthdayNames.length - 1} more people`
              : ""}
          </h2>
        </div>
        <div className="block1-bottom">
          <p>{Constants.Birthday_Wish}</p>
          {/* <div className="for-loader"> */}
          <div className="bottom-buttons">
            <button
              type="button"
              onClick={() => handleSendIndividualWish("all")}
            >
              {sendWishLoader ? <RoundLoader h={"50"} /> : <>Send Greetings</>}
            </button>
            <button type="button" onClick={openSeparateModal}>
              Wish Separately
            </button>
          </div>

          {/* </div> */}
        </div>
      </>
    );
  }

  // making slider active
  function birthdaySliderActive(birthdayNames, nameInitials) {
    return (
      <>
        <div className="block1-slider" style={{ width: width }}>
          <Slider {...birthdaySlider} className="slider single-item">
            {birthdayNames.map((element, key) => (
              <div className="profile-icon" key={key}>
                <div onClick={() => nameSet(birthdayNames[key])}>
                  {nameInitials[key]}
                  <span className="name-hover">{birthdayNames[key]}</span>
                </div>
              </div>
            ))}
          </Slider>
        </div>
        <div className="block1-names">
          <h2>
            <span>
              {`${Constants.Wish}${" "}`}
              {nameTrue === true ? nameHandle : birthdayNames[0]}
            </span>
            {birthdayNames.length > 1
              ? `and ${totalClients - 1} more people`
              : ""}
          </h2>
        </div>
        <div className="block1-bottom">
          <p>{Constants.Birthday_Wish}</p>
          <div className="bottom-buttons">
            <button
              type="button"
              onClick={() => handleSendIndividualWish("all")}
            >
              {sendWishLoader ? <RoundLoader h={"50"} /> : <>Send Greetings</>}
            </button>

            <button type="button" onClick={openSeparateModal}>
              Wish Separately
            </button>
          </div>
        </div>
      </>
    );
  }
  // slider end

  // for modal

  const getBirthDayDetailsForModal = async (NoPage = 1, searchKeyWord = "") => {
    if (NoPage === 1) {
      setModalLoader(true);
    }
    let payloadValue = {
      pageNo: 1,
      pageSize: 10,
      search: searchKeyWord,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getBirthday = await axios.post(
        DASHBOARD_DEFAULT.GetBirthdayList_URL,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );

      let response = ApiResDecrypt(getBirthday?.data);
      if (response?.status === 0) {
        setTotalClients(response?.data?.totalCount);
        setErrorModal(false);
        if (pageNo > 1) {
          setResForModal((prev) => {
            return [...prev, ...response?.data?.birthdays];
          });
        } else {
          setResForModal(response?.data?.birthdays);
        }
      }
    } catch (error) {
      setErrorModal(error?.message);
      console.log(error);
    } finally {
      setModalLoader(false);
      setModalScrollLoader(false);
    }
  };

  const onHide = () => {
    setShowModal(false);
    setPageNo(1);
    setClientSearch("");
    setSelectedFiles([]);
    setResForModal([]);
  };

  const handleModalScroll = async (e) => {
    const a = e.target;
    if (
      a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight &&
      !modalScrollLoader
    ) {
      if (!(totalClients <= 10 * pageNo)) {
        setPageNo((prev) => prev + 1);
        setModalScrollLoader(true);
      }
    }
  };

  const openSeparateModal = () => {
    setShowModal(true);
    getBirthDayDetailsForModal(1, "");
  };
  useEffect(() => {
    if (pageNo > 1) {
      getBirthDayDetailsForModal(pageNo, clientSearch);
    }
  }, [pageNo]);
  //for modal end

  useEffect(() => {
    getBirthDayDetails();
  }, []);

  const handleClientSearch = (data) => {
    getBirthDayDetailsForModal(1, data);
    setPageNo(1);
    setResForModal([]);
  };

  const selectMultiple = (e) => {
    if (e.target.checked) {
      setSelectedFiles((prev) => [...prev, e.target.value]);
    } else {
      const oldSelected = [...selectedFiles];
      const newSelected = oldSelected.filter(function (item) {
        return item !== e.target.value;
      });
      setSelectedFiles(newSelected);
    }
  };

  const handleSendIndividualWish = (sendType) => {
    if (sendType === "individual" && selectedFiles.length === 0) {
      toast.error("Please select atleast 1 client");
    } else {
      sendBirthdayWishCommon(sendType);
    }
    // if (sendType === "all") {
    //   sendBirthdayWishCommon("all");
    // } else if (sendType === "individual") {
    //   if (selectedFiles.length > 0) {
    //     sendBirthdayWishCommon("individual");
    //   } else {
    //   }
    // }
  };

  return (
    <>
      <div className="block1 birthday-block">
        <div className="card-title">
          <h2>
            {Constants.Happy_Birthday} <img src={birthdayCake} alt="" />
          </h2>
        </div>

        {/* returning based on number of bdays */}
        {loader ? (
          <div className="loader-alignment">
            <Loader />
          </div>
        ) : (
          <>
            {birthdayNames.length <= 0
              ? handlingZeroBday(birthdayNames)
              : birthdayNames.length > 0 && birthdayNames.length <= 3
              ? handleBdayCountBetweenOneTOThree(birthdayNames, nameInitials)
              : birthdaySliderActive(birthdayNames, nameInitials)}
          </>
        )}
      </div>

      <Modal
        show={showModal}
        onHide={onHide}
        // size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="setting-model birthday-wrapper-modal"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            <h2 className="model-title">
              {Constants.Happy_Birthday} <img src={birthdayCake} alt="" />
            </h2>
          </Modal.Title>
          <input
            type="search"
            placeholder="Search Client..."
            value={clientSearch}
            onChange={(e) => setClientSearch(e.target.value.toUpperCase())}
          />
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onHide}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>

        <Modal.Body>
          <div className="naked-debit-model table-responsive scroll-table birthday-modal">
            {modalLoader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : (
              <>
                {resForModal && resForModal.length > 0 ? (
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Select</th>
                        <th>Client Code</th>
                        <th>Client Name</th>
                      </tr>
                    </thead>
                    <tbody onScroll={(e) => handleModalScroll(e)} className="">
                      {resForModal.map((name, i) => {
                        return (
                          <tr key={i}>
                            <td>
                              <input
                                type="checkbox"
                                id={name.userId}
                                className="checkSelectProperty"
                                defaultValue={name.userId}
                                defaultChecked={selectedFiles.includes(
                                  name.userId
                                )}
                                onClick={selectMultiple}
                              />
                            </td>
                            <td>
                              <label for={name.userId}>{name.userId}</label>
                            </td>
                            <td className="name-row">
                              <label for={name.userId}>{name.userName}</label>
                            </td>
                          </tr>
                        );
                      })}
                      {modalScrollLoader && (
                        <div className="loader-center">
                          <LoaderForSearch />
                        </div>
                      )}
                    </tbody>
                  </table>
                ) : (
                  !errorModal && (
                    <>
                      {
                        <div className="no-data">
                          <img src={birthdayIcon} alt="birthdayIcon" />
                          <span>{Constants.No_Birthday}</span>
                        </div>
                      }
                    </>
                  )
                )}
              </>
            )}

            {errorModal && (
              <h4 className="no-data">{noDataFound(errorModal)}</h4>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <>
            <button
              type="button"
              className="modal-cancel-btn"
              data-dismiss="modal"
              onClick={onHide}
            >
              Cancel
            </button>
            <button
              type="button"
              className="modal-btn"
              onClick={() => handleSendIndividualWish("individual")}
            >
              {sendWishindiLoader ? (
                <RoundLoader h={"50"} />
              ) : (
                Constants.Send_Greetings
              )}
            </button>
          </>
        </Modal.Footer>
      </Modal>
    </>
  );
}
export default BirthdaySlider;
